import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import CustomBorder from "../_UI/customBorder";

import img1 from '../../theme/assets/svg/tc_tokenomics_s2_icon1.svg';
import img2 from '../../theme/assets/svg/tc_tokenomics_s2_icon2.svg';

import bgM from '../../theme/assets/other/tc_tokenomics_bg_m.png';
import bgD from '../../theme/assets/other/tc_tokenomics_bg_d.png';



const TokenomicsS2 = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.title}`}>{t('Технологические особенности')}:</div>
                <div className={`${Styles.contentBox} ${Styles.contentBoxM}`}>
                    <CustomBorder corners={{}} fill="#0d172a">
                        <div className={`${Styles.contentBoxItem} ${Styles.contentBoxItemP}`}>
                            <div className={`${Styles.contentBoxItemTitle}`}>{t('Технические параметры')}</div>
                            <div className={`${Styles.list}`}>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Название')}:</div>
                                    <div className={`${Styles.listItemValue}`}>Time Capsule Token</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Тикер')}:</div>
                                    <div className={`${Styles.listItemValue}`}>TC</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Стандарт')}:</div>
                                    <div className={`${Styles.listItemValue}`}>BEP-20</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Сеть')}:</div>
                                    <div className={`${Styles.listItemValue}`}>BNB Smart Chain</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Общий выпуск')}:</div>
                                    <div className={`${Styles.listItemValue}`}>1 000 000 000 TC</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Эмиссия')}:</div>
                                    <div className={`${Styles.listItemValue}`}>{t('фиксированная, без дополнительного выпуска')}</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Дробность')}:</div>
                                    <div className={`${Styles.listItemValue}`}>{t('18 знаков')}</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Цена')}:</div>
                                    <div className={`${Styles.listItemValue}`}>1$</div>
                                </div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{}} fill="#0d172a">
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemPosWrap}`}>
                                <div className={`${Styles.colorWrap}`}>
                                    <div className={`${Styles.contentBoxItemTitle}`}>{t('Распределение Токенов')}:</div>
                                    <div className={`${Styles.colorBox}`}>
                                        <div className={`${Styles.colorWrapItem}`}>
                                            <div className={`${Styles.imgWrap}`}>
                                                <img src={img1} alt=""/>
                                            </div>
                                            <div className={`${Styles.textWrap}`}>
                                                <div className={`${Styles.percent}`}>95%</div>
                                                <div className={`${Styles.note}`}>{t('Публичная продажа')}</div>
                                            </div>
                                        </div>
                                        <div className={`${Styles.colorWrapItem}`}>
                                            <div className={`${Styles.imgWrap}`}>
                                                <img src={img2} alt=""/>
                                            </div>
                                            <div className={`${Styles.textWrap}`}>
                                                <div className={`${Styles.percent} ${Styles.percentR}`}>5%</div>
                                                <div className={`${Styles.note} ${Styles.noteR}`}>{t('Программа “Апостол”')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${Styles.bgWrap}`}>
                                    <img src={bgM} alt="capsule"/>
                                </div>
                            </div>
                        </div>
                    </CustomBorder>
                </div>
                <div className={`${Styles.contentBox} ${Styles.contentBoxD}`}>
                    <CustomBorder corners={{ topRight: true, bottomRight: true }} cutSize={15} fill="#0d172a">
                        <div className={`${Styles.contentBoxItem} ${Styles.contentBoxItemP}`}>
                            <div className={`${Styles.contentBoxItemTitle}`}>{t('Технические параметры')}</div>
                            <div className={`${Styles.list}`}>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Название')}:</div>
                                    <div className={`${Styles.listItemValue}`}>Time Capsule Token</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Тикер')}:</div>
                                    <div className={`${Styles.listItemValue}`}>TC</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Стандарт')}:</div>
                                    <div className={`${Styles.listItemValue}`}>BEP-20</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Сеть')}:</div>
                                    <div className={`${Styles.listItemValue}`}>BNB Smart Chain</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Общий выпуск')}:</div>
                                    <div className={`${Styles.listItemValue}`}>1 000 000 000 TC</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Эмиссия')}:</div>
                                    <div className={`${Styles.listItemValue}`}>{t('фиксированная, без дополнительного выпуска')}</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Дробность')}:</div>
                                    <div className={`${Styles.listItemValue}`}>{t('18 знаков')}</div>
                                </div>
                                <div className={`${Styles.listItem}`}>
                                    <div className={`${Styles.listItemName}`}>{t('Цена')}:</div>
                                    <div className={`${Styles.listItemValue}`}>1$</div>
                                </div>
                            </div>
                        </div>
                    </CustomBorder>
                    <CustomBorder corners={{ topLeft: true, bottomLeft: true }} cutSize={15} fill="#0d172a">
                        <div className={`${Styles.contentBoxItem}`}>
                            <div className={`${Styles.contentBoxItemPosWrap}`}>
                                <div className={`${Styles.colorWrap}`}>
                                    <div className={`${Styles.contentBoxItemTitle}`}>{t('Распределение Токенов')}:</div>
                                    <div className={`${Styles.colorBox}`}>
                                        <div className={`${Styles.colorWrapItem}`}>
                                            <div className={`${Styles.imgWrap}`}>
                                                <img src={img1} alt=""/>
                                            </div>
                                            <div className={`${Styles.textWrap}`}>
                                                <div className={`${Styles.percent}`}>95%</div>
                                                <div className={`${Styles.note}`}>{t('Публичная продажа')}</div>
                                            </div>
                                        </div>
                                        <div className={`${Styles.colorWrapItem}`}>
                                            <div className={`${Styles.imgWrap}`}>
                                                <img src={img2} alt=""/>
                                            </div>
                                            <div className={`${Styles.textWrap}`}>
                                                <div className={`${Styles.percent} ${Styles.percentR}`}>5%</div>
                                                <div className={`${Styles.note} ${Styles.noteR}`}>{t('Программа “Апостол”')}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`${Styles.bgWrap}`}>
                                    <img src={bgD} alt="capsule"/>
                                </div>
                            </div>
                        </div>
                    </CustomBorder>
                </div>
            </div>
        </section>
    );
};

export default TokenomicsS2;